import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';

import { CKEditorModule } from 'ckeditor4-angular';

import { NgxPaginationModule } from 'ngx-pagination';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

import { AddClientComponent } from './clients/add-client.component';
import { EditClientComponent } from './clients/edit-client.component';
import { ClientsComponent } from './clients/clients.component';

import { AddSubmissionComponent } from './submissions/add-submission.component';
import { EditSubmissionComponent } from './submissions/edit-submission.component';
import { SubmissionsComponent } from './submissions/submissions.component';
import { AddPropositionComponent } from './propositions/add-proposition.component';

import { PropositionsComponent } from './propositions/propositions.component';

import { CalendarComponent } from './calendar/calendar.component';
import { FollowUpsComponent } from './follow-ups/follow-ups.component';
import { CalendarJobsComponent } from './calendar-jobs/calendar-jobs.component';
import { CalendarForemanComponent } from './calendar-foreman/calendar-foreman.component';

import { ContractsComponent } from './contracts/contracts.component';
//import { AddContractComponent } from './contracts/add-contracts.component';
import { EditContractComponent } from './contracts/edit-contract.component';

import { InvoicesComponent } from './invoices/invoices.component';
import { EditInvoiceComponent } from './invoices/edit-invoice.component';

import { OrdersComponent } from './orders/orders.component';
import { EditOrderComponent } from './orders/edit-order.component';

import { ManagementComponent } from './management/management.component';
import { UsersComponent } from './management/users/users.component';
import { EditUserComponent } from './management/users/edit-user.component';

//import { OrdertemplateComponent } from './ordertemplate.component';
import { EditOrdertemplateComponent } from './management/ordertemplate/edit-ordertemplate.component';
import { TemplatesComponent } from './management/templates/templates.component';
import { EditTemplateComponent } from './management/templates/edit-template.component';
import { AddTemplateComponent } from './management/templates/add-template.component';
import { ContractorsComponent } from './management/contractors/contractors.component';
import { EditContractorComponent } from './management/contractors/edit-contractor.component';
import { AddContractorComponent } from './management/contractors/add-contractor.component';

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  timeGridPlugin,
  listPlugin,
  interactionPlugin
]);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AddClientComponent,
    EditClientComponent,
    ClientsComponent,
    AddSubmissionComponent,
    EditSubmissionComponent,
    SubmissionsComponent,
    AddPropositionComponent,
    PropositionsComponent,
    ManagementComponent,
    EditOrdertemplateComponent,
    UsersComponent,
    EditUserComponent,
    AddTemplateComponent,
    TemplatesComponent,
    EditTemplateComponent,
    ContractorsComponent,
    EditContractorComponent,
    CalendarComponent,
    AddContractorComponent,
    ContractsComponent,
    EditContractComponent,
    InvoicesComponent,
    EditInvoiceComponent,
    OrdersComponent,
    EditOrderComponent,
    FollowUpsComponent,
    CalendarJobsComponent,
    CalendarForemanComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FullCalendarModule,
    CKEditorModule,
    NgxPaginationModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
